import * as React from 'react'

function SvgQueue(props, svgRef) {
  return (
    <svg viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M11.011 8.75a4.373 4.373 0 004.375-4.375A4.373 4.373 0 0011.011 0a4.373 4.373 0 00-4.373 4.256v.034a4.43 4.43 0 00.005.333A4.366 4.366 0 008.531 7.98c.705.486 1.559.77 2.48.77zm3 1.25h-.324a6.167 6.167 0 01-2.676.625c-.256 0-.507-.017-.755-.048l-.003-.003a6.162 6.162 0 01-1.906-.57h-.004L8.336 10H8.27a3.147 3.147 0 00-.146-.004H7.972L7.96 10a4.485 4.485 0 00-1.588.308h-.013a4.497 4.497 0 00-2.852 4.188v1.129c0 .219.04.43.106.625h.005c.258.728.952 1.25 1.768 1.25h11.25c1.036 0 1.875-.84 1.875-1.875V14.5c0-2.484-2.02-4.5-4.5-4.5zM2.34 15.625V14.5a5.644 5.644 0 012.207-4.492l-.012-.004L4.523 10h-.148A4.373 4.373 0 000 14.375c0 1.035.84 1.875 1.875 1.875h.527a3.003 3.003 0 01-.062-.625zm5.042-7.05A3.754 3.754 0 012.495 5c0-2.071 1.68-3.751 3.75-3.751.06 0 .114 0 .173.004a5.532 5.532 0 00-.957 3.121 5.514 5.514 0 001.921 4.2z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgQueue)
export default ForwardRef
